// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_g7Q","cls2":"Search-cls2_ggg Search-cls1_g7Q"};